import React from 'react';
import PropTypes from 'prop-types';

const SectionIntro = ({
  kicker,
  title,
  description,
  actions,
  className = '',
  kickerClassName = '',
  titleClassName = '',
  descriptionClassName = ''
}) => {
  return (
    <div
      className={`section-intro flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${className}`}
    >
      <div className="min-w-0">
        {kicker && (
          <span
            className={`section-intro-kicker mb-2 block font-command-label text-[10px] uppercase tracking-[0.2em] ${kickerClassName}`}
          >
            {kicker}
          </span>
        )}
        <h1
          className={`section-intro-title mt-3 font-command-display text-3xl text-white ${titleClassName}`}
        >
          {title}
        </h1>
        {description && (
          <p
            className={`section-intro-description mt-3 max-w-5xl text-sm leading-6 ${descriptionClassName}`}
          >
            {description}
          </p>
        )}
      </div>

      {actions && (
        <div className="section-intro-actions flex flex-wrap items-center gap-3">{actions}</div>
      )}
    </div>
  );
};

SectionIntro.propTypes = {
  kicker: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  className: PropTypes.string,
  kickerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string
};

SectionIntro.defaultProps = {
  kicker: null,
  description: null,
  actions: null,
  className: '',
  kickerClassName: '',
  titleClassName: '',
  descriptionClassName: ''
};

export default SectionIntro;
